import React from 'react';
import { Outlet } from 'react-router-dom';
import {
  Box,
  Flex,
  useColorModeValue,
  Drawer,
  DrawerContent,
  useDisclosure,
} from '@chakra-ui/react';
import Sidebar from './Sidebar';
import Header from './Header';

/**
 * アプリケーションの基本レイアウト
 * サイドバー、ヘッダー、メインコンテンツ領域を含む
 */
const Layout = () => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  
  return (
    <Box minH="100vh" bg={useColorModeValue('gray.50', 'gray.800')}>
      {/* モバイル用サイドバー（Drawer） */}
      <Drawer
        autoFocus={false}
        isOpen={isOpen}
        placement="left"
        onClose={onClose}
        returnFocusOnClose={false}
        onOverlayClick={onClose}
        size="full"
      >
        <DrawerContent>
          <Sidebar onClose={onClose} />
        </DrawerContent>
      </Drawer>
      
      {/* デスクトップ用サイドバー（固定表示） */}
      <Sidebar
        display={{ base: 'none', md: 'block' }}
        position="fixed"
        height="100vh"
      />
      
      {/* メインコンテンツ */}
      <Box ml={{ base: 0, md: 60 }} p={4}>
        {/* ヘッダー */}
        <Header onOpen={onOpen} />
        
        {/* メインコンテンツ（Outlet経由で子ルートのコンポーネントを表示） */}
        <Box mt={8} px={4}>
          <Outlet />
        </Box>
      </Box>
    </Box>
  );
};

export default Layout;